'use strict';

const isNode = typeof document === 'undefined';

const _ = require('lodash');
const Classnames = require('classnames');
const React = require('react');
const ReactRouter = require('react-router');
const LinkedStateMixin = require('react-addons-linked-state-mixin');

const History = ReactRouter.History;
const Link = ReactRouter.Link;

const Components = require('../../components');
const Constants = require('../../constants');
const Global = require('../../global');

const DeviceImage = Global.DeviceImage;
const Media = Components.Media;
const ResponsiveMixin = Global.ResponsiveMixin;

const ItemTabs = require('./item-tabs.jsx');

import zoom from "../../../../server/public/static/images/collection/zoom.png"

import Adler32 from "adler32-js"

const PRODUCT_THUMB_W = 600;
const PRODUCT_THUMB_H = 400;
const PRODUCT_THUMB_PAD_DESKTOP = 40;
const PRODUCT_THUMB_PAD_MOBILE = 20;
const COMMON_ASPECT_RATIO = 0.6;  // Optimize for common 5:3 aspect ratio

if (!isNode) {
    require('./item-detail.scss');
}

module.exports = React.createClass({
    mixins: [ History, LinkedStateMixin, ResponsiveMixin ],

    render: function() {
        const item = this.props.item.item;

        const tabsWidth  = Constants.Breaks.DesktopWidth - PRODUCT_THUMB_W;

        let pad,
            container_w,
            container_h;

        if (this.state.viewportLayout == 'desktop') {
            pad         = PRODUCT_THUMB_PAD_DESKTOP;
            container_w = PRODUCT_THUMB_W;
            container_h = PRODUCT_THUMB_H - 40;
        } else {
            pad         = PRODUCT_THUMB_PAD_MOBILE;
            container_w = this.state.viewportWidth;
            container_h = COMMON_ASPECT_RATIO * container_w;
        }

        // limit height to PRODUCT_THUMB_W x PRODUCT_THUMB_H; size of co-item-thumb
        const aspect = item.width / item.height;
        let thumb_w = Math.min(item.width, container_w - pad);    
        const thumb_h = Math.min(container_h - pad, thumb_w * (1 / aspect));
        thumb_w = thumb_h * aspect;

        return (
            <div className='co-item-detail'>
                <div className='co-item-detail-column'>
                    {/* .co-item-thumb: */}
                    <ItemImage item              = {item}
                               width             = {thumb_w}
                               height            = {thumb_h}
                               location          = {this.props.location}
                               relatedItemsIndex = {this.props.relatedItemsIndex}
                               groupItemsIndex   = {this.props.groupItemsIndex}
                               pinterest         = {this.props.item.pinterest} />
                </div>
                <div className='co-item-detail-column'>
                    <ItemTabs item     = {this.props.item}
                              width    = {tabsWidth}
                              height   = {container_h - 78}
                              params   = {this.props.params}
                              location = {this.props.location} />
               </div>
               <div className="lightbox">
                    <a href="#" id={item.imageID} className="lightbox-background">
                    <span className="close" id="close"></span>
                    <img className="lightbox-img" src={`//media.strongproject.com/r/${item.width}x${item.height}/${item.filename}`} />
                    </a>
                </div>
            </div>
        );
    }
});

var ItemImage = React.createClass({
    mixins: [ History, LinkedStateMixin, ResponsiveMixin ],

    _onClick: function() {
        // When showing zoomed image, record in history.state the position of the galleries
        // so when the user clicks Back, the gallery page offset is preserved
        history.replaceState({
            'relatedItemsIndex': this.props.relatedItemsIndex.value,
            'groupItemsIndex': this.props.groupItemsIndex.value,
        }, window.location.pathname);
    },
    render: function() {
        var item = this.props.item;
        var thumbStyle = {
            width: Math.round(this.props.width),
            height: Math.round(this.props.height),
        };

        var basepath = this.props.location.pathname.replace(/\/tab\/?(story|finishes|details)$/, '');

        // Move Pinterest badge to top-left of photo
        const PinterestStyle = {
            top:  `calc(${(PRODUCT_THUMB_H - this.props.height) / 2}px + 1em`,
            left: `calc(${(PRODUCT_THUMB_W  - this.props.width) / 2}px + 1em`,
        };
        const itemThumbStyle = this.state.viewportLayout === 'desktop' 
                ? {marginTop:'35px',marginLeft: '20px'}
                : {position:'relative',top:'50%',left:'50%',transform:'translate(-50%,-50%)'} 
        
        const h = new Adler32()
        const primary = (str) => {
            h.reset()
            h.update(str)
            return h.digest('hex')
        }
        return (
            <div className='co-item-thumb'>
            <a href={`#${item.imageID}`} onClick={this._onClick}>
                <div className='co-item-thumb-container' style={thumbStyle}>
                    <Media className = 'co-item-thumb-img'
                        media     = {item}
                        width     = {thumbStyle.width}
                        crossfade />

                    {this.state.viewportLayout == 'desktop' ?
                        <div className='co-item-thumb-zoom'>
                            <DeviceImage src='collection/zoom.png' width="25" height="25" alt="Zoom"/>
                        </div>
                    : null}
                </div>
            </a>
                {this.state.viewportLayout == 'desktop' ?
                    <Components.Pinterest pinterest={this.props.pinterest} style={PinterestStyle} />
                : null}
                </div> 
        );
    }
});




// WEBPACK FOOTER //
// ./src/collections/product/item-detail.jsx